module.exports = __webpack_public_path__ + "img/ananda-pic.8fea4d31.png";